import { NotAuthorizedGuard } from "./not-authorized.guard";

export { NotAuthorizedGuard };

export default [NotAuthorizedGuard];
